import type { ProjectParents } from '@store/reducers/dashboard/types'
import { put, select } from 'redux-saga/effects'

import { InternalProjectActions as Internal } from '../../actions'
import { selectProjectParents } from '../../selectors'

export function* internalMove({
  payload: { id, folderId, workspaceId },
}: ReturnType<typeof Internal.move>) {
  const path: ProjectParents | null = yield select(selectProjectParents(id))
  if (!path) {
    return
  }

  yield put(Internal.delete({ id }))

  yield put(
    Internal.add({
      workspaceId,
      folderId,
      project: { ...path.project, folderId },
    })
  )
}
